import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import querystring from 'query-string';
import { Subject, numberOfSlides, routes } from '../../../constants';
import { getProductsBySubjectId, getProductsBySubjectIdStatus } from '../../../reducers/dashboard.selectors';
import { SearchFilters, SearchResultsTab } from '../../../types/search';
import useRouter from '../../../utils/useRouter';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import NewCarousel from '../../Carousel/NewCarousel';
import { getCommonCardProps } from '../../Search/SearchResults/SearchResults';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import CardSkeleton from '../../Carousel/CardSkeleton';

interface OwnProps {
  subject: Subject;
}

const SubjectCarousel: React.FC<OwnProps> = ({ subject }) => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const products = useSelector(state => getProductsBySubjectId(state, subject.id));
  const loadingStatus = useSelector(state => getProductsBySubjectIdStatus(state, subject.id));
  const slides = new Array(numberOfSlides.xl).fill(null);
  if (products.length < numberOfSlides.xl) return null;

  const onShowAllClick = () => {
    const searchParams: SearchFilters = {
      subject: [subject.id],
      sortBy: 'createdDate'
    };

    const qs = querystring.stringify(searchParams, { skipNull: true });
    const uri = `/${routes.search.root}/${SearchResultsTab.PRODUCTS}?${qs}`;
    router.push(uri);
  };
  
  return (
    <NewCarousel 
      title={t('New in {subject}', { subject: subject.text })}
      onShowAll={onShowAllClick}
    >
      {
        loadingStatus === AsyncActionStatus.READY ? (
          products.map((product) => (
            <DashboardMuiCard 
              key={product.id}
              {...getCommonCardProps({ ...product, type: 'product' })}
              contentType='product' 
            />
          ))
        )
          : slides.map((_, index) => <CardSkeleton key={index} />)
      }
    </NewCarousel>
  );
};

export default SubjectCarousel;
